import React, { useState, useEffect } from 'react';
import '../../css/noMatch.css';
import { Link, useNavigate } from 'react-router-dom';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import imgNoMatch from '../../assets/svg/mainImgNoMatch.svg'
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Heading from '../../components/Heading';
import GifAnim from '../../components/GifAnim';

function AvailableSoon() {

    const isTablet = useTabletMediaQuery();
    const isMobile = useMobileMediaQuery();
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);


  return ( 
    <>
        <Header/> 
        { isLoading ? 
        <GifAnim />
        :
        <div className={ isTablet ? "mainViewContainerNoMatch" : "mainViewContainerNoMatchMobile"}>
            <div className={ isTablet ? 'firstTxtViewContainerNoMatch' : 'firstTxtViewContainerNoMatchMobile' }>
                <Heading hasSaldo={false} goHome />
                <div className={ isTablet ? 'secondMainContainerNoMatch' : 'secondMainContainerNoMatchMobile' } >
                    <div className='mainTxtViewContainerNoMatch'>
                        <div className='txtViewContainerNoMatch'>
                            <div className={ isTablet ? 'txtMainTitleNoMatch' : 'txtMainTitleNoMatchMobile' }>Esta página estará disponível em breve!</div>
                            <div className='mainSubTxtViewContainerNoMatch'>
                                <span className='mainTxtNoMatch'>Estamos a preparar esta página para si. Pode voltar à </span>
                                <Link to="/" className="linkNoMatch">
                                    <span className='mainTxtNavNoMatch'>Homepage </span>
                                </Link>
                                <span className='mainTxtNoMatch'>ou </span>
                                <a href="https://saude360.medis.pt/medis-carteira-virtual" target="_parent" rel="noopener noreferrer" className="linkNoMatch">
                                    <span className='mainTxtNavNoMatch'>saber mais </span>
                                </a>
                                <span className='mainTxtNoMatch'>a Carteira Virtual Médis</span>
                            </div>
                        </div>

                    </div>
                    <div className={ isTablet ? 'mainImgViewNoMatch' : 'mainImgViewNoMatchMobile'}>
                        <img src={imgNoMatch} alt="imagem" className={ isTablet ? 'mainImgNoMatch' : 'mainImgNoMatchMobile' } />
                    </div>
                </div>
            </div>
        </div>
        }
        <Footer/> 
    </>
  )
}

export default AvailableSoon;